exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#side-menu {\n  position: fixed;\n  display: block;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100%;\n  min-width: 320px;\n  overflow: hidden;\n  z-index: 1100;\n}\n.side-menu-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  z-index: 1090;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/js/components/side-menu/side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss
// module id = ./node_modules/css-loader/index.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/js/components/side-menu/side-menu.vue?vue&type=style&index=0&id=2a5ed71f&lang=scss
// module chunks = 4